export default __webpack_public_path__ + "static/media/2021122_FIC2022-BANNER-FOR-WEB-SQ-Click.a6271f49.gif";